// extracted by mini-css-extract-plugin
module.exports = {"digital_box":"digital_box-15ZV5ttQ"};